<template>
  <Teleport to="body">
    <div
      v-if="modelValue"
      class="catalog-insured-search-window"
      :class="{ 'catalog-insured-search-window--nested': nested }"
      :style="{ zIndex: zIndex }"
      role="dialog"
      :aria-label="$t('catalogPersonSearchTitle')"
    >
      <div class="catalog-insured-search-dialog">
        <div class="catalog-insured-search-dialog__header">
          <span class="catalog-insured-search-dialog__title">{{ $t("catalogPersonSearchTitle") }}</span>
        </div>
        <div class="catalog-insured-search-dialog__body">
          <CatalogPersonSearchPanel
            :show-title="false"
            :pin="pin"
            :doc-series="docSeries"
            :doc-number="docNumber"
            :search-mode="searchMode"
            :loading="loading"
            @update:pin="$emit('update:pin', $event)"
            @update:doc-series="$emit('update:docSeries', $event)"
            @update:doc-number="$emit('update:docNumber', $event)"
            @update:search-mode="$emit('update:searchMode', $event)"
            @search="$emit('search')"
          />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import CatalogPersonSearchPanel from "./CatalogPersonSearchPanel.vue";

export default {
  name: "CatalogPersonSearchDialog",
  components: { CatalogPersonSearchPanel },
  props: {
    modelValue: { type: Boolean, default: false },
    pin: { type: String, default: "" },
    docSeries: { type: String, default: "" },
    docNumber: { type: String, default: "" },
    searchMode: { type: String, default: "asan" },
    loading: { type: Boolean, default: false },
    nested: { type: Boolean, default: false },
    zIndex: { type: Number, default: 3008 },
  },
  emits: ["update:modelValue", "update:pin", "update:docSeries", "update:docNumber", "update:searchMode", "search"],
};
</script>
